import content from "@/content/header.json";
import { Link } from "react-router";

interface Data {
  logo: string;
  slogan: string;
}

const data: Data = content;

const Logo = () => {
  return (
    <Link
      to="/"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className="flex w-full items-center justify-center gap-2 md:w-auto md:justify-between"
    >
      <span className="font-display text-foreground text-3xl tracking-wide">
        {data.logo.split(" ")[0]}
        <span className="text-primary">{data.logo.split(" ")[1]}</span>
      </span>
      <span className="text-muted-foreground text-sm font-medium">
        {data.slogan}
      </span>
    </Link>
  );
};

export default Logo;
